import {
  GoAButton,
  GoAContainer,
  GoAFormItem,
  GoATextArea,
} from "@abgov/react-components";
import { useRecoilState } from "recoil";
import { orderPdfState, orderState } from "../../states/Order.state";
import { UserComment } from "../../model/Base";
import { Order } from "../../model/Order";
import { Fragment, useState } from "react";
import { useAuth } from "react-oidc-context";
import {
  orderActionStatusList,
} from "../../common/constants";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { OrderService } from "../../services/OrderService";
import { INotificationMessage } from "../../model/Common";
import {
  notificationMessageState,
  showNotificationState,
} from "../../states/Common.state";
import PageLoader from "../../components/PageLoader";
import { OrderPdf } from "../../model/OrderPdf";
import moment from "moment";

dayjs.extend(advancedFormat);

interface IOrderCommentsProps {
  onCommentAdded?: (value: boolean) => void;
}
const OrderComments: React.FC<IOrderCommentsProps> = (props) => {
  const [order, setOrder] = useRecoilState<Order>(orderState);
  const [orderPdf, setOrderPdf] = useRecoilState<OrderPdf>(orderPdfState);
  const [loading, setIsLoading] = useState(false);
  const [newCommentText, setNewCommentText] = useState<string>("");
  const auth = useAuth();
  const [showNotification, setShowNotification] = useRecoilState<boolean>(
    showNotificationState
  );
  const [notificationMessage, setNotificationMessage] =
    useRecoilState<INotificationMessage>(notificationMessageState);

  const handleAddComment = async () => {
    const newComment: UserComment = {
      id: undefined,
      text: newCommentText,
      username: auth.user?.profile.name ?? "",
      postDate: new Date().toISOString(),
      postDateString: `${dayjs(new Date().toISOString()).tz("America/Edmonton", false).format("dddd, MMMM D, YYYY [at] HH:mm")} (MST)`
    };
    const updatedOrder = { ...order };
    updatedOrder.comments = [...(updatedOrder.comments || []), newComment]?.sort((a: UserComment, b: UserComment) => new Date(b.postDate).getTime() - new Date(a.postDate).getTime());
    setIsLoading(true);
    const result = await OrderService.addComment(updatedOrder);
    if (result.success) {
      setIsLoading(false);
      setShowNotification(true);
      setNotificationMessage({
        messageType: "success",
        messageHeader: "Comment added successfully.",
      });
      console.log(showNotification + "-" + notificationMessage);
      setOrder(updatedOrder);
      const pdfData = { ...updatedOrder };
      pdfData.statusDesc = orderActionStatusList.find(i => i.value === pdfData.status)?.label ?? "";
      pdfData.printDateTime = moment(new Date()).format('YYYY-MM-DD HH:mm');
      pdfData.orderDatePrintable = dayjs.utc(pdfData.orderDate).tz("America/Edmonton", false).format("YYYY-MM-DD HH:mm");
      pdfData.submittedDatePrintable = dayjs.utc(pdfData.submittedDate).tz("America/Edmonton", false).format("YYYY-MM-DD HH:mm");
      pdfData.requiredByPrintable = dayjs.utc(pdfData.requiredBy).tz("America/Edmonton", false).format("YYYY-MM-DD HH:mm");
      setOrderPdf({ ...orderPdf, data: pdfData });
      setNewCommentText("");
    } else {
      setShowNotification(true);
      setNotificationMessage({
        messageType: "error",
        messageHeader: "Error while saving comment",
      });
      console.log(showNotification + "-" + notificationMessage);
      setIsLoading(false);
    }
  };

  const onCommentTextChange = (name: string, value: string) => {
    setNewCommentText(value);
  };


  return (
    <>
      <PageLoader visible={loading} />
      {(
        <div>
          <GoAFormItem label="Add a comment">
            <GoATextArea
              name="comments"
              ariaLabel="test"
              countBy="character"
              maxCount={1200}
              value={newCommentText}
              onChange={onCommentTextChange}
            ></GoATextArea>
          </GoAFormItem>
          <div className="btn-add-comment">
            <GoAButton
              type="secondary"
              onClick={handleAddComment}
              disabled={
                newCommentText.length === 0 ||
                newCommentText.length >
                Number(
                  process.env.REACT_APP_TEXTAREA_ORDER_COMMENTS_CHAR_COUNT
                )
              }
            >
              Add comment
            </GoAButton>
          </div>
        </div>
      )}
      {order?.comments?.map((comment, index) => (
        <GoAContainer maxWidth="min(60ch, 100%)" key={index}>
          <span>
            <span className="comment-username">{comment.username}</span>
            <span className="comment-lastupdated-datetime">
              {` on ${dayjs(comment.postDate)
                .tz("America/Edmonton", false)
                .format("dddd, MMMM D, YYYY [at] HH:mm")} (MST)`}
            </span>
          </span>
          <span className="comment-content">
            {comment.text.split('\n').map((line, i) => (
              <Fragment key={i}>
                {line}
                <br />
              </Fragment>
            ))}
          </span>
        </GoAContainer>
      ))}
    </>
  );
};

export default OrderComments;
